import { setDetectedTimeZone } from "client/Api/TimeZones/userTimeZone";
import { getSystemTimeZone, TimeZone } from "client/DateAndTime/timezones";
import { isNotNil } from "client/Misc/utils";
import { getCurrentCulture } from "client_legacy/ndaw/culture";

export type DetectedTimeZoneResult = {
	detectedTimeZone: TimeZone;
	isAnotherTimeZoneAlreadyPersisted: boolean;
};

export function detectTimeZone(
	previouslyDetectedTimeZoneIdentifier: string | null,
	timeZoneIdentifier: string | null
): DetectedTimeZoneResult | undefined {
	const currentCulture: string = getCurrentCulture();
	const detectedTimeZone: TimeZone = getSystemTimeZone(currentCulture);

	const didDetectedTimeZoneChange: boolean = checkIfTimeZoneChanged(
		previouslyDetectedTimeZoneIdentifier,
		detectedTimeZone
	);

	if (!didDetectedTimeZoneChange) {
		return;
	}

	const didTimeZoneChange: boolean = checkIfTimeZoneChanged(
		timeZoneIdentifier,
		detectedTimeZone
	);

	if (!didTimeZoneChange) {
		// NOTE: This behaves as fire and forget, if we fail to persist user's timezone
		// we can give it another try next time user refreshes the page
		setDetectedTimeZone({
			detectedTimeZone: detectedTimeZone.identifier,
			timeZoneToPersist: { isSet: false }
		})
			.catch(e => console.error(e));
		return;
	}

	if (detectedTimeZone.isSupportedByWorkspace) {
		// NOTE: This behaves as fire and forget, if we fail to persist user's timezone
		// we can give it another try next time user refreshes the page
		setDetectedTimeZone({
			detectedTimeZone: detectedTimeZone.identifier,
			timeZoneToPersist: {
				isSet: true,
				value: detectedTimeZone.identifier
			}
		})
			.catch(e => console.error(e));
		return;
	} else {
		return {
			detectedTimeZone,
			isAnotherTimeZoneAlreadyPersisted: isNotNil(timeZoneIdentifier)
		};
	}
}

function checkIfTimeZoneChanged(
	currentTimeZoneIdentifier: string | null,
	detectedTimeZone: TimeZone
): boolean {
	if (!currentTimeZoneIdentifier) {
		return true;
	}

	return detectedTimeZone.identifier !== currentTimeZoneIdentifier;
}